
































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { TimeLineArticleDTO } from "@/common/api";
import { formatImageUrl } from "@/common/utils";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const noImage = require("@/assets/images/muuq-base/noimage.png");

@Component({
  name: "BlogItem",
})
export default class BlogItem extends Vue {
  @Prop({
    default: () => [],
  })
  article: TimeLineArticleDTO;

  get articleImage() {
    return this.article.images && this.article.images[0]
      ? formatImageUrl(this.article.images[0].name, "640x427")
      : noImage;
  }

  get groupImage() {
    return this.article.group?.image
      ? formatImageUrl(this.article.group.image.name, "110x110")
      : noImage;
  }
}
